import BadgeSection from "./_components/badge-section";

export default BadgeSection;
